import React, { useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import LibraryAddSharpIcon from '@material-ui/icons/LibraryAddSharp';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { FormControl, FormGroup, FormLabel, Card } from '@material-ui/core';
import { utils } from '../../../utils';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import LoadingHook from '../../hooks/LoadingHook'
import { useDispatch, useSelector } from 'react-redux';
import S3List_Hook from '../../hooks/S3List_Hook';
import { ActionProd_SELLER_newProduct } from '../../../store/action/action-product';
import { Alert } from '@material-ui/lab';
import S3FileUpload_Hook from '../../hooks/S3FileUpload_Hook';



const useStyles = makeStyles((theme) => ({
    paper: {
        // marginTop: theme.spacing(12),
        // marginBottom: theme.spacing(15),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '3rem',
        margin: '4rem 0',
        width: '100%',
    },
    avatar: {
        // margin: theme.spacing(7),
        width: theme.spacing(7),
        height: theme.spacing(7),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    sizeList: {
        margin: '1rem',
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));
export default function NewProductScreen() {
    const classes = useStyles();

    const { user } = useSelector(state => state.reducer_user)

    const dispatch = useDispatch()


    const [txtState, setTxtState] = useState({})
    const [chbSelected, setChbSelected] = useState([]);
    const [imgSelected, setImgSelected] = useState()
    const [errMsg, setErrMsg] = useState()
    const [isForm_Loading, setIsForm_Loading] = useState()

    function chbHandleChange(event, item) {
        console.log('item:', item)
        if (event.target.checked) {
            setChbSelected([...chbSelected, item]);
        } else {
            setChbSelected((prev) =>
                prev.filter((currItem) => currItem !== item)
            );
        }

    }

    const txtHandleChange = (event) => {
        setTxtState({ ...txtState, [event.target.name]: event.target.value });
        //console.log('txtState:', txtState)
    };

    const setSelectedImg = (img) => {
        setImgSelected(img)
    }



    const submitForm = (e) => {
        e.preventDefault();
        try {

            setIsForm_Loading(true)
            if (chbSelected.length === 0) {
                setErrMsg('Sizes: is a required field')
                return false;
            }


            if (!imgSelected) {
                setErrMsg('Image: is a required field')
                return false;
            }
            setErrMsg(undefined)

            var newProduct = {
                availableSizes: chbSelected,
                ...txtState,
                image: imgSelected,
                seller: user._id
            }
            console.log(' newProduct:', newProduct)

            dispatch(ActionProd_SELLER_newProduct(newProduct))


            setIsForm_Loading(false);

        } catch (error) {
            setErrMsg(error)
            setIsForm_Loading(false);
        }
        return false;
    }




    return (
        <Container component="main" maxWidth="sm">
            <CssBaseline />

            <Card className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <LibraryAddSharpIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Product Entry
                </Typography>
                <form className={classes.form} onSubmit={submitForm} >  {/* noValidate */}
                    <TextField
                        id="prodTitle"
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        label="Product Title"
                        name="title"
                        onChange={txtHandleChange}
                        autoFocus
                    />
                    <TextField
                        id="prodDesc"
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        label="Product Description"
                        name="description"
                        onChange={txtHandleChange}
                    />
                    <TextField
                        id="prodPrice"
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        label="Product Price $"
                        name="price"
                        type="number"
                        onChange={txtHandleChange}
                    // InputProps={{startAdornment: <InputAdornment position="start">$</InputAdornment>, }}
                    />


                    <div className='gal-root'>
                        <Typography gutterBottom variant='h4' color="textSecondary" className='gal-header'>
                            Available Sizes
                        </Typography>
                        <FormControl component="fieldset" className={classes.sizeList} >
                            <FormLabel component="legend">Types :: {"  " + chbSelected.length > 0 ? chbSelected.length : null}
                            </FormLabel>
                            <FormGroup aria-label="position" row style={{ marginTop: '0.5rem' }} >
                                {
                                    utils.constants.cSizes.slice(1).map((sz) => (
                                        <FormControlLabel
                                            key={sz}
                                            value={sz}
                                            control={<Checkbox color="primary" />}
                                            label={sz}
                                            name={sz}
                                            onChange={(e) => chbHandleChange(e, sz)}
                                            labelPlacement="top"
                                        />
                                    ))
                                }
                            </FormGroup>
                        </FormControl>
                    </div>
                    {/* 
                    <FormControl component="fieldset" className={classes.sizeList} >
                        <FormLabel component="legend">Available Sizes :: {"  " + chbSelected.length > 0 ? chbSelected.length : null}
                        </FormLabel>
                        <FormGroup aria-label="position" row style={{ marginTop: '0.5rem' }} >
                            {
                                utils.constants.cSizes.slice(1).map((sz) => (
                                    <FormControlLabel
                                        key={sz}
                                        value={sz}
                                        control={<Checkbox color="primary" />}
                                        label={sz}
                                        name={sz}
                                        onChange={(e) => chbHandleChange(e, sz)}
                                        labelPlacement="top"
                                    />
                                ))
                            }
                        </FormGroup>
                    </FormControl> */}

                    <S3FileUpload_Hook selectedImg={setSelectedImg} user={user} />

                    <S3List_Hook selectedImg={setSelectedImg} style={{ border: '1px dashed', margin: '1rem 0' }} />


                    {errMsg && <Alert severity="warning">{errMsg} </Alert>}

                    {isForm_Loading && <LoadingHook isSmall />}


                    <div className="btnB">
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            size='large'
                            className={classes.submit}
                            startIcon={<CloudUploadIcon style={{ fontSize: 33 }} />}
                        >
                            Save
                        </Button>
                    </div>

                </form>
            </Card>
        </Container>
    );
}